module.exports = __webpack_public_path__ + "static/img/1194.3e1a0585.png";